<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>账号</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">全部账号</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddUser && !hideInUserEdit">
      <section class="searchBox">
        <span>
          <label>身份:</label>
          <a-select
            defaultValue="全部"
            v-model="typeSearch"
            style="min-width: 120px"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, i) in typeList"
              :key="i"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>认证状态:</label>
          <a-select
            defaultValue="全部"
            v-model="authenticationSearch"
            style="min-width: 120px"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, i) in authenticationList"
              :key="i"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>虚拟账号：</label>
          <a-radio-group v-model="is_temp">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>用户姓名：</label>
          <a-input
            style="width: 160px"
            v-model="query_field"
            placeholder="请输入用户姓名/手机号码"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.user_name }}</td>
              <td>{{ item.create_time.substring(0, 10) }}</td>
              <td>
                <span v-if="item.role_info[0].role_type == 1">内部员工</span>
                <span v-else-if="item.role_info[0].role_type == 2">员工</span>
                <span v-else>客户</span>
              </td>
              <td>
                <span v-for="item in item.role_info" :key="item.id"
                  >{{ item.role_name }}；</span
                >
              </td>
              <td>
                <span v-if="item.gender == 1">男</span>
                <span v-else-if="item.gender == 2">女</span>
                <span v-else>--</span>
              </td>
              <td>{{ item.phone }}</td>
              <td>
                <div v-if="item.role_info[0].role_type == 2">
                  <span v-if="item.identity_status == 1">已认证</span>
                  <span v-else>未认证</span>
                </div>
                <span v-else>--</span>
              </td>
              <td>
                <span v-if="item.status == 1">禁用</span>
                <span v-else>正常</span>
              </td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
                <a
                  @click="onDisable(item.id)"
                  v-if="item.status == 0"
                  style="color: #666"
                  >禁用</a
                >
                <a @click="onTestore(item.id)" v-if="item.status == 1">恢复</a>
                <a @click="resetPassword(item.id)" style="color: red"
                  >重置密码</a
                >
                <a @click="onLogout(item.id)">注销账号</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addUser v-on:hideInAdd="hideInAdd" v-if="hideInAddUser" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <userEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import addUser from "@/components/account/addUser"; //增加用户
import userEdit from "@/components/account/userEdit"; //编辑用户
import { mapState } from "vuex";

export default {
  components: {
    addUser,
    userEdit,
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      typeList: [
        {
          label: "全部",
          value: -1,
        },
        {
          label: "员工",
          value: 2,
        },
        {
          label: "内部员工",
          value: 1,
        },
        {
          label: "客户员工",
          value: 3,
        },
      ],
      typeListTabel: [
        {
          label: "员工",
          value: 2,
        },
        {
          label: "内部员工",
          value: 1,
        },
        {
          label: "客户员工",
          value: 3,
        },
      ],
      hideInAddUser: false,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      authenticationList: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "已认证",
          value: 1,
        },
        {
          label: "未认证",
          value: 2,
        },
      ],
      thList: [
        "用户名",
        "注册日期",
        "岗位类型",
        "岗位名称",
        "性别",
        "手机号码",
        "认证状态",
        "账号状态",
        "操作",
      ],
      query_field: "",
      authenticationSearch: 0,
      typeSearch: -1,
      is_temp: -1,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onLogout(id) {
      let self = this;
      this.$confirm({
        title: "注销账号?",
        content: "确认注销后，我们将实时删除该账号的个人信息和历史数据，数据删除后无法找回，请谨慎操作！",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url +
            self.httpsBasic.user +
            "identity/cancelUser";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              user_id: id,
            })
            .then((res) => {
              if (res.data.code == 200) {
                self.$message.success("注销成功");
                self.getData();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {},
      });
    },
    resetPassword(id) {
      let self = this;
      this.$confirm({
        title: "重置账号?",
        content: "重置密码后，新密码为当前手机号的后六位!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url +
            self.httpsBasic.user +
            "User/updatePasswordByUserId";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              user_id: id,
            })
            .then((res) => {
              if (res.data.code == 200) {
                self.$message.success("重置成功");
                self.getData();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {},
      });
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function () {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddUser = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddUser = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/userList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          token: window.localStorage.getItem("xnwfPcToken"),
          role_type: this.typeSearch,
          identity_status: this.authenticationSearch,
          is_temp: this.is_temp,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    onDisable(id) {
      const self = this;
      this.$confirm({
        title: "禁用账号?",
        content: "账号一旦禁用，将无法使用系统!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url + self.httpsBasic.user + "User/setUserStatus";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              user_id: id,
              status: 1,
            })
            .then((res) => {
              if (res.data.code == 200) {
                self.$message.success("禁用成功");
                self.getData();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {},
      });
    },
    onTestore(id) {
      const self = this;
      this.$confirm({
        title: "恢复账号?",
        content: "确定恢复其账号的使用权限!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url + self.httpsBasic.user + "User/setUserStatus";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              user_id: id,
              status: 0,
            })
            .then((res) => {
              if (res.data.code == 200) {
                self.$message.success("操作成功");
                self.getData();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {},
      });
    },
    onReset() {
      this.query_field = "";
      this.authenticationSearch = 0;
      this.typeSearch = -1;
      this.is_temp = -1;
      this.page = 1;
      this.getData();
    },
  },
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
